import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import { ViewerModelSym } from '@wix/thunderbolt-symbols'
import { StyleUtilsDefinition as definition } from '@wix/viewer-service-style-utils/definition'
import { StyleUtilsService as impl } from '@wix/viewer-service-style-utils/implementations'
import type { ServiceProvider, ViewerModel } from '@wix/thunderbolt-symbols'
import type { IStyleUtilsDefinition } from '@wix/viewer-service-style-utils/definition'

export const styleUtilsService: FactoryWithDependencies<ServiceProvider<IStyleUtilsDefinition, typeof impl>> =
	withDependencies(
		[ViewerModelSym],
		(viewerModel: ViewerModel): ServiceProvider<IStyleUtilsDefinition, typeof impl> => {
			const config = { isResponsive: viewerModel.site.isResponsive }

			return {
				definition,
				impl,
				config,
				platformConfig: config,
			}
		}
	)
